import {useQuery} from 'react-query';
import {getRecieverData} from '.';

const useGetRecieverData = ({
  supplierGuid,
  onSuccess,
  onError,
}: IuseGetRecieverProps) => {
  const {data, isLoading, refetch} = useQuery({
    queryKey: ['store-chat', supplierGuid],
    queryFn: () => getRecieverData(supplierGuid),
    enabled: Boolean(supplierGuid),
    onSuccess,
    onError,
  });
  return {data, isLoading, refetch};
};
export default useGetRecieverData;
